// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
//

import localizer from 'share/localization/Izenda.Localizer';

const DEFAULT_VALUE = 0;
const DEFAULT_SETTINGS = [
  {
    type: 0,
    topValue: 0.75,
    bottomValue: 0.75,
    leftValue: 0.7,
    rightValue: 0.7,
    headerValue: 0.3,
    footerValue: 0.3
  },
  {
    type: 1,
    topValue: 0.75,
    bottomValue: 0.75,
    leftValue: 0.25,
    rightValue: 0.25,
    headerValue: 0.3,
    footerValue: 0.3
  },
  {
    type: 2,
    topValue: 1,
    bottomValue: 1,
    leftValue: 1,
    rightValue: 1,
    headerValue: 0.5,
    footerValue: 0.5
  },
  {
    type: 3,
    topValue: 0.75,
    bottomValue: 0.75,
    leftValue: 0.7,
    rightValue: 0.7,
    headerValue: 0.3,
    footerValue: 0.3
  }
];
const MARGIN_VALUE = {
  NORMAL: 0,
  NARROW: 1,
  WIDE: 2,
  CUSTOM: 3
};
const ORIENTATION_VALUE = {
  PORTRAIT: 0,
  LANDSCAPE: 1
};

const SETTINGS_KEY = {
  ORIENTATION: 'orientation',
  MARGIN: 'margins',
  HORIZONTALLY: 'horizontally',
  VERTICALLY: 'vertically',
  PAGEBREAK: 'pageBreakAfterReportPart'
};
const COLS_LAYOUT = {
  MIN: 2,
  MEDIUM: 4,
  MAX: 8
};

const MARGIN_KEY = {
  TOP: 'top',
  LEFT: 'left',
  BOTTOM: 'bottom',
  HEADER: 'header',
  RIGHT: 'right',
  FOOTER: 'footer'
};

export default {
  DEFAULT_VALUE,
  DEFAULT_SETTINGS,
  get MARGIN_OPTIONS() {
    return [
      { label: localizer.getText('EXPORT_CONSTANTS_LABEL_NORMAL'), value: MARGIN_VALUE.NORMAL },
      { label: localizer.getText('EXPORT_CONSTANTS_LABEL_NARROW'), value: MARGIN_VALUE.NARROW },
      { label: localizer.getText('EXPORT_CONSTANTS_LABEL_WIDE'), value: MARGIN_VALUE.WIDE },
      { label: localizer.getText('EXPORT_CONSTANTS_LABEL_CUSTOM'), value: MARGIN_VALUE.CUSTOM }
    ];
  },
  get ORIENTATION_OPTIONS() {
    return [
      {
        label: localizer.getText('EXPORT_CONSTANTS_LABEL_PORTRAINT'),
        value: ORIENTATION_VALUE.PORTRAIT,
        icon: 'icon-doc'
      },
      {
        label: localizer.getText('EXPORT_CONSTANTS_LABEL_LANDSCAPE'),
        value: ORIENTATION_VALUE.LANDSCAPE,
        icon: 'icon-doc-landscape'
      }
    ];
  },
  SETTINGS_KEY,
  MARGIN_VALUE,
  ORIENTATION_VALUE,
  COLS_LAYOUT,
  LABEL_COL: 5,
  CONTROL_COL: 7,
  get MARGIN_INPUT() {
    return {
      TOP: localizer.getText('EXPORT_CONSTANTS_LABEL_MARGIN_TOP'),
      LEFT: localizer.getText('EXPORT_CONSTANTS_LABEL_MARGIN_LEFT'),
      BOTTOM: localizer.getText('EXPORT_CONSTANTS_LABEL_MARGIN_BOTTOM'),
      HEADER: localizer.getText('EXPORT_CONSTANTS_LABEL_MARGIN_HEADER'),
      RIGHT: localizer.getText('EXPORT_CONSTANTS_LABEL_MARGIN_RIGHT'),
      FOOTER: localizer.getText('EXPORT_CONSTANTS_LABEL_MARGIN_FOOTER')
    };
  },
  get LABEL() {
    return {
      ORIENTATION: localizer.getText('EXPORT_CONSTANTS_LABEL_ORIENTATION'),
      MARGIN: localizer.getText('EXPORT_CONSTANTS_LABEL_MARGIN'),
      CENTER_ON_PAGE: localizer.getText('EXPORT_CONSTANTS_LABEL_CENTER_ON_PAGE'),
      HORIZONTALLY: localizer.getText('EXPORT_CONSTANTS_LABEL_HORIZONTALLY'),
      VERTICALLY: localizer.getText('EXPORT_CONSTANTS_LABEL_VERTICALLY'),
      PAGE_BREAK: localizer.getText('EXPORT_CONSTANTS_LABEL_PAGE_BREAK')
    };
  },
  MARGIN_KEY,
  MAX_WIDTH: 7.78,
  MAX_HEIGHT: 11.68,
  MIN_WIDTH: 0.5,
  MIN_HEIGHT: 0.01
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ExportConstants.js